(() => {
  'use strict';
  const roots = document.querySelectorAll('[data-genies-finder]');
  if (!roots.length) return;
  const cache = new Map();
  const read = (store, key) => { try { return JSON.parse(store.getItem(key)); } catch { return null; } };
  const write = (store, key, value) => { try { store.setItem(key, JSON.stringify(value)); return true; } catch { return false; } };
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
  const fetchJSON = async url => {
    if (!cache.has(url)) cache.set(url, fetch(url, { credentials: new URL(url, location.origin).origin === location.origin ? 'same-origin' : 'omit', signal: AbortSignal.timeout(20000) }).then(r => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); }).catch(e => { cache.delete(url); throw e; }));
    return cache.get(url);
  };
  roots.forEach(root => {
    const config = JSON.parse(root.querySelector('[data-finder-config]').textContent);
    const t = config.text;
    const $ = s => root.querySelector(s);
    const make = $('[name="vehicle_make"]'), model = $('[name="vehicle_model"]'), year = $('[name="vehicle_year"]');
    const engine = $('[name="vehicle_engine"]'), trim = $('[name="vehicle_trim"]');
    const status = $('[data-finder-status]'), results = $('[data-finder-results]'), summary = $('[data-vehicle-summary]');
    let index, shard, current = null, loadVersion = 0, searchVersion = 0, vinVehicle = null, selectedCategory = "";
    const setStatus = text => { status.textContent = text; };
    let cameraStream = null, scanTimer = null, scanDeadline = null, scanGeneration = 0;
    const scanStatus = $('[data-scan-status]');
    const stopScan = () => {
      scanGeneration++;
      clearTimeout(scanTimer); clearTimeout(scanDeadline);
      if (cameraStream) cameraStream.getTracks().forEach(track => track.stop());
      cameraStream = null;
      $('[data-scan-video]').srcObject = null;
      $('[data-scan-camera]').hidden = true;
      $('[data-scan-start]').disabled = false;
    };
    const extractVIN = text => {
      const value = String(text || '').trim().toUpperCase();
      const matches = [...value.matchAll(/(?:^|[^A-Z0-9])([A-HJ-NPR-Z0-9]{17})(?=$|[^A-Z0-9])/g)];
      const vins = [...new Set(matches.map(m => m[1]))];
      return vins.length === 1 ? vins[0] : null;
    };
    const detector = async () => {
      if (!('BarcodeDetector' in window)) return null;
      const supported = await BarcodeDetector.getSupportedFormats();
      const formats = ['code_39','code_128','pdf417','qr_code','data_matrix'].filter(f => supported.includes(f));
      return formats.length ? new BarcodeDetector({ formats }) : null;
    };
    const acceptScan = codes => {
      const values = [...new Set(codes.map(code => extractVIN(code.rawValue)).filter(Boolean))];
      if (values.length !== 1) return false;
      $('[name="vehicle_vin"]').value = values[0];
      stopScan(); scanStatus.textContent = t.scanFound;
      $('[name="vehicle_vin"]').focus();
      return true;
    };
    $('[data-scan-start]').addEventListener('click', async () => {
      stopScan(); scanStatus.textContent = '';
      const generation = scanGeneration;
      $('[data-scan-start]').disabled = true;
      try {
        const reader = await detector();
        if (!reader) { scanStatus.textContent = t.scanUnavailable; return; }
        if (!navigator.mediaDevices?.getUserMedia) { scanStatus.textContent = t.scanCameraError; return; }
        const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: { ideal: 'environment' }, width: { ideal: 1280 } }, audio: false });
        if (generation !== scanGeneration) { stream.getTracks().forEach(track => track.stop()); return; }
        cameraStream = stream;
        const video = $('[data-scan-video]'); video.srcObject = stream;
        $('[data-scan-camera]').hidden = false; await video.play(); scanStatus.textContent = t.scanReading;
        scanDeadline = setTimeout(() => { stopScan(); scanStatus.textContent = t.scanTimeout; }, 60000);
        const tick = async () => {
          if (generation !== scanGeneration || !cameraStream) return;
          try { if (video.readyState >= 2) { const codes = await reader.detect(video); if (generation !== scanGeneration) return; if (acceptScan(codes)) return; } } catch {}
          if (generation === scanGeneration) scanTimer = setTimeout(tick, 250);
        };
        tick();
      } catch { stopScan(); scanStatus.textContent = t.scanCameraError; }
      finally { if (!cameraStream) $('[data-scan-start]').disabled = false; }
    });
    $('[data-scan-photo-trigger]').addEventListener('click', () => $('[data-scan-photo]').click());
    $('[data-scan-photo]').addEventListener('change', async event => {
      stopScan(); scanStatus.textContent = '';
      const file = event.target.files?.[0]; if (!file) return;
      let image;
      try {
        const reader = await detector(); if (!reader) { scanStatus.textContent = t.scanUnavailable; return; }
        image = await createImageBitmap(file);
        if (!acceptScan(await reader.detect(image))) scanStatus.textContent = t.scanNotFound;
      } catch { scanStatus.textContent = t.scanNotFound; }
      finally { image?.close(); event.target.value = ''; }
    });
    $('[data-scan-stop]').addEventListener('click', () => { stopScan(); scanStatus.textContent = ''; });
    document.addEventListener('visibilitychange', () => { if (document.hidden) stopScan(); });
    window.addEventListener('pagehide', stopScan);
    const tabs = [...root.querySelectorAll('[data-finder-tab]')];
    const activate = mode => {
      stopScan(); scanStatus.textContent = '';
      searchVersion++;
      tabs.forEach(tab => { const active = tab.dataset.finderTab === mode; tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1; });
      root.querySelectorAll('[data-finder-panel]').forEach(panel => { panel.hidden = panel.dataset.finderPanel !== mode; });
      results.replaceChildren(); setStatus(''); summary.textContent = current ? vehicleText(current) : '';
      persistVehicle();
      if (mode === 'catalog' && make.value && model.value && year.value) search();
    };
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => activate(tab.dataset.finderTab));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (i + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); activate(tabs[next].dataset.finderTab); tabs[next].focus(); }
      });
    });
    const option = (text, value) => new Option(text, value);
    const options = (select, values, label) => { select.replaceChildren(option(label, '')); values.forEach(value => select.add(option(String(value), String(value)))); select.disabled = !values.length; };
    const resetDetails = () => { engine.value = ''; trim.value = ''; $('[data-engine-list]').replaceChildren(); $('[data-extra-details]').hidden = false; };
    const clearResults = () => { results.replaceChildren(); summary.textContent = ''; current = null; vinVehicle = null; };
    const assetURL = name => config.index.replace(/genies-fitment-index\.json/, name);
    const loadMake = async () => {
      const version = ++loadVersion;
      const chosen = make.value;
      options(model, [], t.model); options(year, [], t.year); resetDetails();
      if (!chosen) return;
      setStatus(t.loading);
      try {
        const data = await fetchJSON(assetURL(index.makes[chosen].file));
        if (version !== loadVersion) return;
        shard = data;
        options(model, Object.keys(index.makes[chosen].models), t.model);
        setStatus(t.chooseVehicle);
      } catch { if (version === loadVersion) setStatus(t.loadError); }
    };
    const loadYears = () => {
      options(year, model.value ? index.makes[make.value].models[model.value] : [], t.year);
      resetDetails();
    };
    const loadEngines = () => {
      const rows = baseRows();
      const engines = [...new Set(rows.map(r => shard.d[2][r[3]]).filter(Boolean))].sort();
      engine.value = ''; trim.value = '';
      $('[data-engine-list]').replaceChildren(...engines.map(v => option(v, v)));
      $('[data-extra-details]').hidden = false;
    };
    const baseRows = () => shard && model.value && year.value ? shard.r.filter(r => r[1] === Number(year.value) && shard.d[1][r[2]] === model.value) : [];
    const normalizeEngine = value => { const match = String(value).match(/(\d+(?:[.,]\d+)?)\s*(?:l\b|$)/i); return match ? String(Number(match[1].replace(',', '.'))) + 'l' : normalize(value); };
    const relevantRows = () => baseRows().filter(r => !engine.value.trim() || !shard.d[2][r[3]] || normalizeEngine(shard.d[2][r[3]]) === normalizeEngine(engine.value));
    const vehicleText = v => [v.year, v.make, v.model, v.engine, v.trim].filter(Boolean).join(' · ');
    const snapshotVehicle = () => ({make:make.value, model:model.value, year:year.value, engine:engine.value.trim(), trim:trim.value.trim()});
    const persistVehicle = () => {
      const vehicle = snapshotVehicle();
      $('[data-active-vehicle]').textContent = vehicleText(vehicle) || t.noVehicle;
      write(sessionStorage, 'genies_vehicle_draft_v2', {...vehicle, part:$('[name="vehicle_part"]').value, category:selectedCategory});
      if (vehicle.make && vehicle.model && vehicle.year) write(sessionStorage, 'genies_vehicle_session_v1', vehicle);
    };
    const categoryPatterns = {
      discs:/disque.*frein|brake.*(?:rotor|disc)/i,
      pads:/plaquette|brake.*pad/i,
      calipers:/[eé]trier|caliper/i,
      filters:/filtre|filter/i,
      bearings:/roulement|moyeu|bearing|wheel hub/i,
      arms:/bras.*suspension|control arm/i,
      links:/biellette|stabiliz.*link|sway.*link/i,
      struts:/amortisseur|jambe.*suspension|shock|strut/i,
      axles:/arbre.*(?:essieu|transmission)|cv axle|axle shaft/i,
      compressors:/compresseur|compressor/i
    };
    const updateCategoryButtons = () => root.querySelectorAll('[data-part-category]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.partCategory === selectedCategory)));
    root.querySelectorAll('[data-part-category]').forEach(button => button.addEventListener('click', () => {
      selectedCategory = button.dataset.partCategory;
      const disclosure = button.closest('details'); if (disclosure) disclosure.open = false;
      $('[name="vehicle_part"]').value = '';
      updateCategoryButtons(); persistVehicle();
      if (!make.value || !model.value || !year.value) { activate('vehicle'); setStatus(t.noVehicle); return; }
      search();
    }));
    $('[data-edit-vehicle]').addEventListener('click', () => { activate('vehicle'); make.focus(); });
    const productURL = item => {
      const url = new URL(config.root + 'products/' + item[0], location.origin);
      url.searchParams.set('variant', item[2]);
      const preview = new URLSearchParams(location.search).get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      return url.href;
    };
    const textNode = (tag, text, className) => { const el = document.createElement(tag); el.textContent = text; if (className) el.className = className; return el; };
    const hydrationQueue = [];
    let hydrationActive = 0;
    const runHydration = () => {
      while (hydrationActive < 4 && hydrationQueue.length) {
        const task = hydrationQueue.shift();
        if (!task.card.isConnected) continue;
        hydrationActive++;
        task.run().finally(() => { hydrationActive--; runHydration(); });
      }
    };
    const cardTasks = new WeakMap();
    const cardObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      entries.forEach(entry => { if (entry.isIntersecting) { cardObserver.unobserve(entry.target); const task = cardTasks.get(entry.target); if (task) { hydrationQueue.push(task); cardTasks.delete(entry.target); runHydration(); } } });
    }, {rootMargin:'300px'}) : null;
    const addCard = (sku, item, rows, direct = false) => {
      const card = document.createElement('article'); card.className = 'gv-card';
      card.dataset.sku = sku;
      card.append(textNode('span', t.skuLabel + ' : ' + sku, 'gv-sku'));
      const link = document.createElement('a'); link.href = productURL(item); link.textContent = item[1]; link.className = 'gv-product-link';
      const price = textNode('p', t.priceLoading, 'gv-price');
      const brand = textNode('p', '', 'gv-brand');
      const availability = textNode('p', '', 'gv-availability');
      card.append(link, brand, price, availability);
      if (rows.length) card.append(textNode('p', vehicleText(snapshotVehicle()), 'gv-card-vehicle'));
      card.append(textNode('p', t.confirm, 'gv-confirm'));
      if (rows.length) {
        const list = document.createElement('ul');
        [...new Set(rows.map(r => [shard.d[2][r[3]] || t.engineUnpublished, shard.d[3][r[4]], shard.d[4][r[5]]].filter(Boolean).join(' · ')))].forEach(text => list.append(textNode('li', text)));
        card.append(list);
      }
      card.append(textNode('p', direct ? t.skuWarning : t.rowWarning, 'gv-note'));
      const view = document.createElement('a'); view.href = link.href; view.textContent = t.viewProduct; view.className = 'gv-view-product'; card.append(view);
      results.append(card);
      const task = {card, run:async () => {
        try {
          const product = await fetchJSON(config.root + 'products/' + item[0] + '.js');
          if (!card.isConnected) return;
          const variant = product.variants?.find(v => String(v.id) === String(item[2]) && String(v.sku) === sku);
          if (!variant) { price.textContent = t.identityUnavailable; link.removeAttribute('href'); view.remove(); return; }
          link.textContent = product.title + (variant.title && variant.title !== 'Default Title' ? ' — ' + variant.title : '');
          brand.textContent = product.vendor ? t.brandLabel + ' : ' + product.vendor : '';
          price.textContent = Number.isFinite(variant.price) && variant.price > 0 && config.currency ? new Intl.NumberFormat(config.locale || document.documentElement.lang, {style:'currency',currency:config.currency,currencyDisplay:'code'}).format(variant.price / 100) : t.priceUnavailable;
          availability.textContent = variant.available ? t.available : t.unavailable;
          const image = variant.featured_image?.src || product.featured_image;
          if (image) { const img = document.createElement('img'); img.src = image; img.alt = link.textContent; img.loading = 'lazy'; img.width = 120; img.height = 120; card.prepend(img); }
        } catch { if (card.isConnected) price.textContent = t.priceUnavailable; }
      }};
      if (cardObserver) { cardTasks.set(card, task); cardObserver.observe(card); }
      else { hydrationQueue.push(task); runHydration(); }
    };
    const selectedSku = () => {
      const variant = new URLSearchParams(location.search).get('variant');
      return (config.variants.find(v => String(v.id) === variant) || config.variants[0] || {}).sku;
    };
    const checkProduct = rows => {
      const sku = selectedSku();
      const matching = rows.filter(r => shard.d[0][r[0]] === sku);
      const panel = document.createElement('div'); panel.className = 'gv-check-panel';
      panel.append(textNode('strong', t.confirm), textNode('p', sku || t.skuMissing));
      if (matching.length) {
        panel.append(textNode('p', t.foundApplication));
        const list = document.createElement('ul');
        matching.forEach(r => list.append(textNode('li', [shard.d[2][r[3]] || t.engineUnpublished, shard.d[3][r[4]], shard.d[4][r[5]]].filter(Boolean).join(' · '))));
        panel.append(list, textNode('p', t.rowWarning));
      } else panel.append(textNode('p', t.noProductProof));
      results.append(panel);
    };
    const search = async () => {
      const version = ++searchVersion;
      if (!make.value || !model.value || !year.value) { setStatus(t.required); return; }
      results.replaceChildren();
      current = { make: make.value, model: model.value, year: year.value, engine: engine.value.trim(), trim: trim.value.trim() };
      write(sessionStorage, 'genies_vehicle_session_v1', current);
      persistVehicle();
      summary.textContent = vehicleText(current);
      const rows = relevantRows();
      if (config.variants.length) {
        checkProduct(rows); setStatus(t.checked); return;
      }
      const grouped = new Map();
      const partQuery = $('[name="vehicle_part"]').value.trim();
      const terms = partQuery.toLowerCase().split(/\s+/).filter(w => !['de','du','des','la','le','les','the','for','a'].includes(w)).map(w => normalize(w).replace(/s$/, '')).filter(Boolean);
      const aliases = {brake:'frein',rotor:'disque',pad:'plaquette',filter:'filtre',bearing:'roulement',caliper:'etrier',front:'avant',rear:'arriere',left:'gauche',right:'droit',delantero:'avant',delantera:'avant',adelante:'avant',trasero:'arriere',trasera:'arriere',atras:'arriere',derecho:'droit',derecha:'droit',izquierdo:'gauche',izquierda:'gauche',freno:'frein',pastilla:'plaquette',disco:'disque',filtro:'filtre'};
      const matchPart = (sku, item, row) => {
        const text = normalize(sku + ' ' + item[1] + ' ' + shard.d[3][row[4]]);
        return (!selectedCategory || categoryPatterns[selectedCategory]?.test(item[1])) && terms.every(term => {
          const translated = aliases[term] || term;
          if (['avant','arriere','gauche','droit'].includes(translated)) return normalize(shard.d[3][row[4]]).includes(translated);
          return text.includes(term) || (aliases[term] && text.includes(aliases[term]));
        });
      };
      rows.forEach(r => { const sku = shard.d[0][r[0]]; const item = index.products[sku]; if (!item || !matchPart(sku, item, r)) return; if (!grouped.has(sku)) grouped.set(sku, []); grouped.get(sku).push(r); });
      if (version !== searchVersion) return;
      grouped.forEach((rs, sku) => addCard(sku, index.products[sku], rs));
      setStatus(grouped.size ? t.results.replace('{count}', grouped.size) : t.noResults);
    };
    make.addEventListener('change', async () => { clearResults(); const pending = loadMake(); persistVehicle(); await pending; persistVehicle(); });
    model.addEventListener('change', () => { clearResults(); loadYears(); persistVehicle(); });
    year.addEventListener('change', () => { clearResults(); loadEngines(); persistVehicle(); });
    engine.addEventListener('input', () => { clearResults(); persistVehicle(); });
    trim.addEventListener('input', () => { clearResults(); persistVehicle(); });
    $('[name="vehicle_part"]').addEventListener('input', () => { results.replaceChildren(); setStatus(''); persistVehicle(); });
    $('[data-vehicle-form]').addEventListener('submit', event => { event.preventDefault(); search(); });
    $('[data-save-vehicle]').addEventListener('click', () => {
      current = snapshotVehicle(); if (!current.make || !current.model || !current.year) { setStatus(t.required); return; } persistVehicle();
      setStatus(write(localStorage, 'genies_vehicle_v1', current) ? t.saved : t.saveError);
    });
    $('[data-clear-vehicle]').addEventListener('click', () => {
      try { localStorage.removeItem('genies_vehicle_v1'); sessionStorage.removeItem('genies_vehicle_session_v1'); sessionStorage.removeItem('genies_vehicle_draft_v2'); } catch {}
      current = null; make.value = ''; options(model, [], t.model); options(year, [], t.year); resetDetails(); clearResults(); selectedCategory = ''; $('[name="vehicle_part"]').value = ''; updateCategoryButtons(); $('[data-active-vehicle]').textContent = t.noVehicle; setStatus(t.cleared);
    });
    $('[data-sku-form]').addEventListener('submit', async event => {
      event.preventDefault(); if (!index) return;
      const entered = $('[name="part_number"]').value.trim();
      if (!entered) return;
      if (!$('[data-search-all]').checked && make.value && model.value && year.value) {
        selectedCategory = ''; updateCategoryButtons(); $('[name="vehicle_part"]').value = entered;
        activate('parts'); await search(); return;
      }
      const version = ++searchVersion;
      results.replaceChildren(); summary.textContent = entered;
      const match = Object.keys(index.products).find(s => s.toUpperCase() === entered.toUpperCase());
      if (match) { addCard(match, index.products[match], [], true); setStatus(t.exactSku); }
      else {
        setStatus(t.loading);
        try {
          const query = new URLSearchParams({ q: entered, 'resources[type]': 'product', 'resources[limit]': '8', 'resources[options][fields]': 'title,variants.sku' });
          const data = await fetchJSON(config.root + 'search/suggest.json?' + query);
          const candidates = data.resources?.results?.products || [];
          const found = await Promise.all(candidates.map(async candidate => {
            const product = await fetchJSON(config.root + 'products/' + candidate.handle + '.js');
            const exact = product.variants?.find(v => String(v.sku).toUpperCase() === entered.toUpperCase());
            const variant = exact || product.variants?.[0];
            return variant ? { exact: !!exact, sku: String(variant.sku || ''), item: [product.handle, product.title, String(variant.id), product.featured_image] } : null;
          }));
          if (version !== searchVersion) return;
          const exacts = found.filter(p => p?.exact);
          const display = exacts.length ? exacts : found.filter(Boolean);
          if (display.length) {
            display.forEach(p => addCard(p.sku, p.item, [], true));
            setStatus(exacts.length === 1 ? t.exactSku : t.partsResults.replace('{count}', display.length));
            if (!exacts.length) {
              const link = document.createElement('a'); link.className = 'gv-more-results'; link.textContent = t.moreResults;
              link.href = config.root + 'search?' + new URLSearchParams({ q: entered, type: 'product' }); results.append(link);
            }
          } else setStatus(t.skuNotFound);
        } catch { setStatus(t.loadError); }
      }
    });
    const restore = async v => {
      const matchedMake = Object.keys(index.makes).find(m => normalize(m) === normalize(v.make));
      if (!matchedMake) return false;
      make.value = matchedMake; await loadMake();
      const matchedModel = Object.keys(index.makes[matchedMake].models).find(m => normalize(m) === normalize(v.model));
      if (!matchedModel) return false;
      model.value = matchedModel; loadYears(); year.value = String(v.year); if (!year.value) return false;
      loadEngines();
      engine.value = v.engine || ''; trim.value = v.trim || '';
      return true;
    };
    $('[data-vin-form]').addEventListener('submit', async event => {
      event.preventDefault(); if (!index) return;
      const input = $('[name="vehicle_vin"]'); const vin = input.value.trim().toUpperCase();
      results.replaceChildren(); summary.textContent = ''; current = null; vinVehicle = null;
      $('[data-vin-go]').hidden = true;
      if (!/^[A-HJ-NPR-Z0-9]{17}$/.test(vin)) { setStatus(t.invalidVin); input.focus(); return; }
      const button = $('[data-vin-submit]'); button.disabled = true; setStatus(t.decoding);
      try {
        const response = await fetchJSON('https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVinValuesExtended/' + encodeURIComponent(vin) + '?format=json');
        const v = response.Results?.[0];
        if (!v || v.ErrorCode !== '0' || !v.Make || !v.Model || !v.ModelYear) { setStatus(t.vinIncomplete); return; }
        const decoded = { make: v.Make, model: v.Model, year: v.ModelYear, engine: v.DisplacementL ? String(Number(v.DisplacementL)) + 'L' : '', trim: v.Trim || v.Series || '' };
        const applied = await restore(decoded);
        results.replaceChildren();
        results.append(textNode('p', t.vinIdentified + ' ' + vehicleText(decoded) + (v.DriveType ? ' · ' + v.DriveType : '') + '. ' + t.vinWarning, 'gv-check-panel'));
        vinVehicle = decoded;
        summary.textContent = vehicleText(decoded);
        if (applied) { $('[data-vin-go]').hidden = false; setStatus(t.vinReady); }
        else setStatus(t.vinNotInCatalogue);
      } catch { setStatus(t.vinError); }
      finally { button.disabled = false; }
    });
    $('[data-vin-go]').addEventListener('click', () => { activate('vehicle'); search(); });
    document.addEventListener('change', event => { if (current && event.target.matches('[name="id"]')) search(); });
    const variantObserver = new MutationObserver(() => {
      const selected = selectedSku();
      if (root.dataset.checkedSku !== selected && current && config.variants.length) { root.dataset.checkedSku = selected; search(); }
    });
    if (config.variants.length) variantObserver.observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
    fetchJSON(config.index).then(async data => {
      index = data; options(make, Object.keys(index.makes), t.make); $('[data-vehicle-submit]').disabled = false; $('[data-sku-submit]').disabled = false; $('[data-vin-submit]').disabled = false;
      setStatus('');
      const saved = read(sessionStorage, 'genies_vehicle_draft_v2') || read(sessionStorage, 'genies_vehicle_session_v1') || read(localStorage, 'genies_vehicle_v1');
      if (saved) { await restore(saved); $('[name="vehicle_part"]').value = saved.part || ''; selectedCategory = categoryPatterns[saved.category] ? saved.category : ''; updateCategoryButtons(); persistVehicle(); }
      if (saved && make.value && model.value && year.value) { current = snapshotVehicle(); if (config.variants.length) { activate('vehicle'); await search(); } else setStatus(''); }
    }).catch(() => setStatus(t.loadError));
  });
})();
